//Email validator adapted from hibernate
var atom = "[a-z0-9!#$%&'*+/=?^_`{|}~-]";
var domain = "(" + atom + "+(\\." + atom + "+)*";
var ip_domain = "\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\]";
var email = new RegExp("^" + atom + "+(\\." + atom + "+)*@" + domain + "|" + ip_domain + ")$", "i");

export default {
    /**
     * Validate an email address.  This follows the same standard hibernate uses for email validation.
     * @param test email address
     * @returns {boolean} True if the test address is empty or valid.
     */
    validate: function(test) {
        return !test || email.test(test);
    }
};